import { useEffect } from 'react';

/**
 * Component to dynamically update page title, description, and favicon from settings
 * This component fetches public settings and updates the document head
 */
const DynamicMetaTags = () => {
  useEffect(() => {
    const updateMetaTags = async () => {
      try {
        const response = await fetch(`${window.location.origin}/api/settings/public`);
        const settings = await response.json();
        
        // Update page title
        if (settings.site_name) {
          document.title = settings.site_name;
          
          // Also update Open Graph title for social sharing
          let ogTitle = document.querySelector('meta[property="og:title"]');
          if (!ogTitle) {
            ogTitle = document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            document.head.appendChild(ogTitle);
          }
          ogTitle.setAttribute('content', settings.site_name);
        }
        
        // Update meta description
        if (settings.site_description) {
          const metaDesc = document.querySelector('meta[name="description"]') || 
                          document.getElementById('meta-description');
          if (metaDesc) {
            metaDesc.setAttribute('content', settings.site_description);
          }
          
          // Also update Open Graph description for social sharing
          let ogDesc = document.querySelector('meta[property="og:description"]');
          if (!ogDesc) {
            ogDesc = document.createElement('meta');
            ogDesc.setAttribute('property', 'og:description');
            document.head.appendChild(ogDesc);
          }
          ogDesc.setAttribute('content', settings.site_description);
        }
        
        // Update favicon
        if (settings.site_favicon) {
          // Remove existing favicon links
          const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
          existingFavicons.forEach(favicon => favicon.remove());
          
          // Create new favicon link
          const favicon = document.createElement('link');
          favicon.rel = 'icon';
          favicon.type = 'image/x-icon';
          favicon.href = `${window.location.origin}${settings.site_favicon}`;
          document.head.appendChild(favicon);
          
          // Also set as Open Graph image for social sharing
          let ogImage = document.querySelector('meta[property="og:image"]');
          if (!ogImage && settings.site_logo) {
            ogImage = document.createElement('meta');
            ogImage.setAttribute('property', 'og:image');
            ogImage.setAttribute('content', `${window.location.origin}${settings.site_logo}`);
            document.head.appendChild(ogImage);
          }
        }
        
        // Set Open Graph URL
        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (!ogUrl) {
          ogUrl = document.createElement('meta');
          ogUrl.setAttribute('property', 'og:url');
          document.head.appendChild(ogUrl);
        }
        ogUrl.setAttribute('content', window.location.href);
        
      } catch (error) {
        console.log('Could not fetch settings for meta tags', error);
      }
    };
    
    updateMetaTags();
  }, []);
  
  return null; // This component doesn't render anything
};

export default DynamicMetaTags;
